import React, { Component } from 'react';
import Trees from '../../../Images/trees.jpeg'
import Money from '../../../Images/money.jpeg'
import Smoke from '../../../Images/smoke.jpeg'

const SavedRow =(props)=>{
    return (
        <div>
            
            <div className="savedIcons" style={{color: props.styleColor}}>
                <div className="text-center">
                    <img src={Trees} alt="" width="120px" style={{display: props.treeDisplay, margin: "0 auto"}}/>
                    <img src={Money} alt="" width="120px" style={{display: props.moneyDisplay, margin: "0 auto"}}/>
                    <img src={Smoke} alt="" width="120px" style={{display: props.smokeDisplay, margin: "0 auto"}}/>
                </div>
            </div>
            <h3 className="savedBody">{props.title} <span style={{fontWeight: 700}}>{props.body}</span></h3>
        </div>
    )

}

export default SavedRow;


// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/InformationCards/SavedRow.jsx